/**
 * How an admin-initiated password reset reaches the user. Email is unusable for
 * accounts whose stored address is a placeholder, so the caller chooses.
 */
export var PasswordResetMode;
(function (PasswordResetMode) {
    /** identity mails a reset link; nothing is returned. */
    PasswordResetMode["EMAIL"] = "PASSWORD_RESET_MODE_EMAIL";
    /** identity sets a generated password and returns it for the admin to relay. */
    PasswordResetMode["TEMP_PASSWORD"] = "PASSWORD_RESET_MODE_TEMP_PASSWORD";
})(PasswordResetMode || (PasswordResetMode = {}));
//# sourceMappingURL=authentication.js.map